import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useJobs } from '../hooks/useJobs';
import { useValves } from '../hooks/useValves';
import NotifierContext from './Contexts/NotifierContext';
import { SiteContext } from './Contexts/SiteContext';
import AdHocJobDialog from './Dialogs/AdHocJobDialog';
import JobsTable from './JobsTable';
import PrivilegesContext from './Contexts/PrivilegesContext';

function Jobs() {

    const { contributor, admin } = useContext(PrivilegesContext);
    const { sitesAssignedToUser, selectedSite } = useContext(SiteContext);
    const notifier = useContext(NotifierContext);

    const { jobs, setJobs, loading, error } = useJobs(selectedSite);
    const { valves, loading: loadingValves } = useValves(selectedSite);
    const [showAdHocJobDialog, setShowAdHocJobDialog] = useState(false);

    // Ref if required for SignalR to have access to the jobs state
    const jobsRef = useRef(jobs);
    useEffect(() => {
        jobsRef.current = jobs;
    }, [jobs]);

    const onJobUpdate = useCallback((data) => {
        var jobUpdate = data.detail.data;
        if (jobUpdate.State === "New" || jobUpdate.State === "Deleted") {
            return;
        }
        if (jobUpdate.action === "NoActionRequired") {
            const jobListWithUpdatedJob = jobsRef.current.filter(x => x.id !== jobUpdate.id);
            setJobs(jobListWithUpdatedJob);
            return;
        }
        const jobListWithUpdatedJob = jobsRef.current.filter(x => x.id !== jobUpdate.id);
        jobListWithUpdatedJob.push(jobUpdate)
        setJobs(jobListWithUpdatedJob);
    }, [setJobs]);

    const onNewJob = useCallback((data) => {
        var job = data.detail.data;
        if (job.State === "New" || job.action === "NoActionRequired") {
            return;
        }

        const newJobList = [...jobsRef.current];
        newJobList.push(job)
        setJobs(newJobList);
    }, [setJobs]);

    // Get jobs and set signalR updates
    useEffect(() => {
        notifier.on("jobUpdate", onJobUpdate);
        notifier.on("newJob", onNewJob);

        return function cleanup() {
            notifier.off("jobUpdate", onJobUpdate);
            notifier.off("newJob", onNewJob);
        };
    }, [notifier, onJobUpdate, onNewJob]);

    // When a job is updated, update the selected job and the table
    const updateJob = (job) => {
        if (job) {
            const jobListWithUpdatedJob = jobs.map(x => x.id === job.id ? { ...x, ...job } : x);
            setJobs(jobListWithUpdatedJob);
        }
    };

    if (sitesAssignedToUser !== undefined && selectedSite === undefined) {
        return (
            <div className="d-flex flex-column mt-5">
                <h4 className="text-center">User has no assigned sites or no site selected</h4>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-end align-items-center mb-2">
                {contributor &&
                    <Button variant="primary" onClick={() => setShowAdHocJobDialog(true)} disabled={loadingValves}>Ad hoc Change</Button>
                }
                {admin &&
                    <Link className="ms-2" to="/job-history">Job History</Link>
                }
            </div>
            <JobsTable jobs={jobs} setJobs={setJobs} updateJob={updateJob} loading={loading} error={error} valves={valves} loadingValves={loadingValves} />
            <AdHocJobDialog show={showAdHocJobDialog} closeDialog={() => setShowAdHocJobDialog(false)} jobs={jobs} setJobs={setJobs} valves={valves} loadingValves={loadingValves} selectedSite={selectedSite} />
        </>
    );
}

export default Jobs;
